import React, { useState, useEffect } from "react"
import { Link, useParams } from "react-router-dom"
import {
  Table,
  CardBody,
  CardTitle,
  Button,
  Col,
  Row,
  UncontrolledAlert,
  Spinner,
} from "reactstrap"
import api from "API/Api"
import {
  AvForm,
  AvField,
  AvRadioGroup,
  AvRadio,
} from "availity-reactstrap-validation"

const EditMaterial = () => {
  const user = localStorage.getItem("authUser")
  const userInfo = JSON.parse(user)
  const { id } = useParams()
  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)
  const [material, setMaterial] = useState([])

  useEffect(() => {
    getInfo()
  }, [])

  const getInfo = async () => {
    const response = await api.get("unit-type/" + id)
    setMaterial(response.data.data[0])
  }

  const handleValidSubmit = async (event, values) => {
    setLoading(true)
    try {
    const updateUnit = await api.put("update-unit/" + id, values)
    if (updateUnit.data.success === true) setSubmitted(true)
    } catch (error) {

      // Handled by global interceptor

    }

    setLoading(false)
  }
  return (
    <>
      <div className="dashBody">
        <div className="font-size-18 mb-0 dashHeader">
          <Row>
            <Col md={6}>
              <h4>Edit Material Unit Type</h4>
            </Col>
            <Col md={6} style={{ textAlign: "right" }}>
              <Link to="/material-unit-type" className="dashBtn">
                <i className=" fas fa-chevron-left "></i> <b> Back</b>
              </Link>
            </Col>
          </Row>
        </div>
        <div className="dashContent">
          <AvForm
            style={{ position: "relative" }}
            className="form-horizontal"
            onValidSubmit={(e, v) => {
              handleValidSubmit(e, v)
            }}
          >
            <div className="mb-3">
              <AvField
                name="unitName"
                label="Material Unit Type Name"
                value={material.unitName}
                className="form-control"
                placeholder="Enter Plant Name"
                type="text"
                required
              />
            </div>
            <div className="mb-3">
              <AvRadioGroup
                inline
                name="allowDecimal"
                label=" Allow Decimal Values for this Unit Type"
                required
                errorMessage="Pick one!"
                value={material.allowDecimal}
              >
                <AvRadio label="Yes" value="1" />
                <AvRadio label="No" value="0" />
              </AvRadioGroup>
            </div>
            <AvField
              name="addedBy"
              value={userInfo.uid}
              type="hidden"
              required
            />

            <div className="mb-3 row mt-4">
              <div className="col-6">
                {submitted ? (
                  <UncontrolledAlert color="success">
                    <strong>Material Unit Type is Updated!</strong>
                  </UncontrolledAlert>
                ) : null}
              </div>
              <div className="col-6 text-end">
                <button
                  className="btn btn-primary w-md waves-effect waves-light"
                  type="submit"
                      disabled={loading}
                >
                  {loading ? (
                    <>
                      <Spinner animation="border" size="sm" />
                      <span style={{ paddingLeft: "10px" }}>Updating...</span>
                    </>
                  ) : (
                    <span>Update Material Unit </span>
                  )}
                </button>
              </div>
            </div>
          </AvForm>
        </div>
      </div>
    </>
  )
}

export default EditMaterial
